/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/ban-ts-ignore */

import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import {TabEnum}                              from "@/util/enums/TabEnum";
// @ts-ignore
import UIkit                                  from "uikit";

@Module
export default class Sidebar extends VuexModule {
    private _displaySidebar = false
    private _currentTab     = TabEnum.SearchBar;

    get displaySidebar() {
        return this._displaySidebar;
    }

    get currentTab() {
        return this._currentTab;
    }

    @Mutation
    setCurrentTab(tab: TabEnum) {
        this._currentTab = tab;
    }

    @Action({commit: 'setCurrentTab'})
    changeTab(tab: TabEnum) {
        UIkit.offcanvas('#off-sidebar').hide();
        return tab;
    }

    @Action({commit: 'setCurrentTab'})
    closeTab() {
        return TabEnum.SearchBar;
    }
}